import { useRef, useEffect } from 'react';
import { ScienceIcon } from '@ui/icons/material/Science';
import { LibraryBooksIcon } from '@ui/icons/material/LibraryBooks';
import { EmojiEventsIcon } from '@ui/icons/material/EmojiEvents';
import '../styles/research.css';

interface ResearchItem {
  id: number;
  icon: React.ReactNode;
  title: string;
  description: string;
  value: string;
}

const researchItems: ResearchItem[] = [
  {
    id: 1,
    icon: <ScienceIcon size="lg" />,
    title: 'Đề tài nghiên cứu',
    description: 'Các đề tài khoa học hàng năm',
    value: '150+'
  },
  {
    id: 2,
    icon: <LibraryBooksIcon size="lg" />,
    title: 'CTĐT Đại học',
    description: 'Chương trình đào tạo chất lượng cao',
    value: '06'
  },
  {
    id: 3,
    icon: <EmojiEventsIcon size="lg" />,
    title: 'CTĐT Thạc sĩ AUN-QA',
    description: 'Chương trình đạt chuẩn quốc tế',
    value: '07'
  },
];

export default function Research() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              (entry.target as HTMLElement).style.animation = 'fadeUp 0.8s ease forwards';
              (entry.target as HTMLElement).style.opacity = '1';
            }, index * 120);
          }
        });
      },
      { threshold: 0.1 }
    );

    itemsRef.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="research section" id="research" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title fade-up">Nghiên cứu khoa học</h2>

        {/*<div className="research-grid">
          {researchItems.map((item, index) => (
            <div
              key={item.id}
              className="research-card fade-up"
              ref={(el) => (itemsRef.current[index] = el)}
            >
              <div className="research-icon-wrapper">{item.icon}</div>
              <div className="research-value">{item.value}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>*/}

        <div className="research-content fade-up">
          <div className="research-section-left">
            <h3>Hoạt động khoa học</h3>
            <div className="achievement-items">
              <div className="achievement">
                  <span>Nghiên cứu ứng dụng y học</span>
              </div>
              <div className="achievement">
                  <span>Hợp tác nghiên cứu quốc tế</span>
              </div>
              <div className="achievement">
                  <span>Công bố bài báo khoa học quốc tế</span>
              </div>
              {/*<div className="achievement">
                  <span>Đề án cấp bộ, cấp quốc gia</span>
              </div>*/}
              <div className="achievement">
                  <span>Sáng chế, bằng sáng chế</span>
              </div>
            </div>
          </div>

          <div className="research-section-right">
            <h3>Kết quả nổi bật</h3>
            <div className="achievement-items">
              <div className="achievement">
                <span>150 Nhiệm vụ KHCN các cấp/năm</span>
              </div>
              <div className="achievement">
                <span>Xuất bản Tạp chí Y Dược học Cần Thơ</span>
              </div>
              <div className="achievement">
                <span>Thành lập Hội đồng GS cơ sở tại Trường</span>
              </div>
              <div className="achievement">
                <span>Giải thưởng khoa học quốc tế</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}